import apiClient from './client';

export interface ChatMessage {
  id: number;
  conversation_id: number;
  role: 'user' | 'assistant';
  role_label: string;
  content: string;
  ai_model: string | null;
  prompt_tokens: number | null;
  completion_tokens: number | null;
  cost_usd: number;
  created_at: string | null;
}

export interface ChatConversation {
  id: number;
  title: string;
  context_type: string | null;
  context_id: number | null;
  message_count: number;
  last_message_at: string | null;
  created_at: string | null;
  updated_at: string | null;
  messages?: ChatMessage[];
}

export interface PaginatedConversations {
  success: boolean;
  data: ChatConversation[];
  meta: {
    current_page: number;
    last_page: number;
    per_page: number;
    total: number;
  };
}

export const chatApi = {
  list(page = 1, perPage = 20): Promise<PaginatedConversations> {
    return apiClient.get('/chat', { params: { page, per_page: perPage } }).then((r) => r.data);
  },

  create(title?: string): Promise<{ success: boolean; data: ChatConversation }> {
    return apiClient.post('/chat', { title }).then((r) => r.data);
  },

  find(id: number): Promise<{ success: boolean; data: ChatConversation }> {
    return apiClient.get(`/chat/${id}`).then((r) => r.data);
  },

  sendMessage(id: number, message: string): Promise<{ success: boolean; data: ChatMessage }> {
    return apiClient.post(`/chat/${id}/messages`, { message }).then((r) => r.data);
  },

  destroy(id: number): Promise<void> {
    return apiClient.delete(`/chat/${id}`).then(() => undefined);
  },
};
